import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class BaseService {
  constructor(protected http: HttpClient) { }

  protected get<T>(url: string, params?: HttpParams): Observable<T> {
    return this.http.get<T>(url, { params })
      .pipe(catchError(this.handleError));
  }
  protected postDelete<T>(url: string, params?: HttpParams): Observable<T> {
    return this.http.post<T>(url, { params })
      .pipe(catchError(this.handleError));
  }
  protected post<T>(url: string, body: any): Observable<T> {
    return this.http.post<T>(url, body)
      .pipe(catchError(this.handleError));
  }
  protected postFormData<T>(url: string, formData: FormData): Observable<T> {
    return this.http.post<T>(url, formData)
      .pipe(catchError(this.handleError));
  }

  protected put<T>(url: string, body: any): Observable<T> {
    return this.http.put<T>(url, body)
      .pipe(catchError(this.handleError));
  }

  protected delete<T>(url: string): Observable<T> {
    return this.http.delete<T>(url)
      .pipe(catchError(this.handleError));
  }

  protected patch<T>(url: string, body: any): Observable<T> {
    return this.http.patch<T>(url, body)
      .pipe(catchError(this.handleError));
  }

  // Error handling
  private handleError(error: any) {
    console.error('API Error: ', error);
    return throwError(() => error);
  }
}
